module.exports = __webpack_public_path__ + "img/lunbo101.292f359.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand_img/lunbo101.png
// module id = yTEY
// module chunks = 0